module.exports = require('./src/google-maps-api-loader.js');



//////////////////
// WEBPACK FOOTER
// ./~/google-maps-api-loader/index.js
// module id = 1563
// module chunks = 0